<template>
<div class="chapter">
<div class="inner_page">
<p class="ebook-toc" id="_idParaDest-2"><span class="ch-opener CharOverride-3"><a id="_idTextAnchor001"></a>contents</span></p>
<div class="l1">
<p class="Normal th"><a href="#/SparksPhoenix_epub4#_idParaDest-4"><span class="ch-opener CharOverride-4"></span><span class="ch-opener CharOverride-5">I      the burning</span></a></p>
<p class="Normal th"><span href="#/SparksPhoenix_epub5#_idParaDest-5" title="Link target outside of Sample"><span class="ch-opener CharOverride-5">II     turning to ashes</span></span></p>
<p class="Normal th"><span href="#/SparksPhoenix_epub6#_idParaDest-6" title="Link target outside of Sample"><span class="ch-opener CharOverride-5">III    sparks of phoenix</span></span></p>
<p class="Normal th"><span href="#/SparksPhoenix_epub7#_idParaDest-7" title="Link target outside of Sample"><span class="ch-opener CharOverride-5">IV    the rising</span></span></p>
<p class="Normal th"><span href="#/SparksPhoenix_epub8#_idParaDest-8" title="Link target outside of Sample"><span class="ch-opener CharOverride-5">V      the soaring</span></span></p>
<p class="Normal th"><span href="#/SparksPhoenix_epub9#_idParaDest-9" title="Link target outside of Sample"><span class="ch-opener CharOverride-5">VI    a new chapter</span></span></p>
</div>
<div class="l2">
<p class="Normal t1 ParaOverride-2"><span href="#/SparksPhoenix_epub10#_idParaDest-10" title="Link target outside of Sample"><span class="ch-opener CharOverride-4">		an invitation</span></span></p>
<p class="Normal"><span href="#/SparksPhoenix_epub11#_idParaDest-11" title="Link target outside of Sample"><span class="ch-opener CharOverride-4">		acknowledgments</span></span></p>
<p class="Normal"><span href="#/SparksPhoenix_epub12#_idParaDest-12" title="Link target outside of Sample"><span class="ch-opener CharOverride-4">		about the author</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SparksPhoenix_epub2.vue?dac83b0e